import { mapState } from "vuex";

export default {
  methods: {
    // Optional clientId parameter
    // Uses the user's clientId if not provided
    isPaymentCardEnabled(clientId = undefined) {
      if (clientId) {
        const client = (this.clients || []).find((c) => c.clientId === clientId);

        if (client) {
          return client.paymentCardEnabled !== false;
        }
      }
      return this.userProfile?.Client?.paymentCardEnabled !== false;
    },
  },
  computed: {
    ...mapState(["userProfile", "clients"]),
  },
};
